import isString from '../TypeHelpers/isString';
import isNumber from '../TypeHelpers/isNumber';
import isSymbol from '../TypeHelpers/isSymbol';
/**
 * Returns a Selector for the given type.
 */
export default function createSelector(propertyNameOrSelector) {
    if (isString(propertyNameOrSelector) || isNumber(propertyNameOrSelector) || isSymbol(propertyNameOrSelector)) {
        return (a) => a[propertyNameOrSelector];
    }
    else {
        return propertyNameOrSelector;
    }
}
